// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"493":"5223b23bd2eee23f","704":"888579694a3b3b33"}[chunkId] + ".js";
};